import { CategorySelectType } from '../widgets/CategorySelect';
import { getSingleSelectDefaultValue } from './defaultValue';

export function categoryTranslate(
  categoryOptions: { text: string; textCn: string; value: string }[],
) {
  const categoryMap: { [key: string]: { text: string; textCn: string } } =
    categoryOptions.reduce(
      (acc, cur) => {
        const { value, text, textCn } = cur;
        const key = value.toLocaleLowerCase();
        return {
          ...acc,
          [key]: { text, textCn },
        };
      },
      {
        other: {
          text: 'Others',
          textCn: '其他',
        },
        others: {
          text: 'Others',
          textCn: '其他',
        },
      },
    );
  return (value: string, isEn: boolean) => {
    const key = value?.toLocaleLowerCase() || '';
    const data = categoryMap[key];

    if (data) {
      return isEn ? data.text : data.textCn;
    }

    return value || '-';
  };
}

export function timeRangeTranslate(
  timeRangeOptions: { text: string; textCn: string; value: string }[],
) {
  const timeRangeMap: { [key: string]: { text: string; textCn: string } } =
    timeRangeOptions.reduce((acc, cur) => {
      const { value, text, textCn } = cur;
      const key = value.toLocaleLowerCase();
      return {
        ...acc,
        [key]: { text, textCn },
      };
    }, {});
  return (value: string, isEn: boolean) => {
    const key = value?.toLocaleLowerCase() || '';
    const data = timeRangeMap[key];

    if (data) {
      return isEn ? data.text : data.textCn;
    }

    return value;
  };
}

export function getCategoryCommonDefaultValue(
  filterValue: any,
  props: CategorySelectType,
) {
  const { filterOptions, options, valueKeys, channelFilterValue } = props;
  const list = filterOptions(options, filterValue, channelFilterValue);
  return getSingleSelectDefaultValue(filterValue, valueKeys, list);
}

export function getCategoryCommonBackValue(
  filterValue: any,
  props: CategorySelectType,
) {
  const key = props.valueKeys;
  const value = filterValue[key];
  return { [key]: value ? [value] : [] };
}
